<span type="button" class="close-button" [mat-dialog-close]="false">
  <mat-icon class="close-icon">close</mat-icon>
</span>

<h1 mat-dialog-title>
  <span class="warning-icon" [setSVGAttributes]="svgAttributes" [inlineSVG]="'assets/uds_icons/report.ods.svg'"></span> {{'common.warning_txt' | translate}}!
</h1>

<div mat-dialog-content class="content">
  <div class="missing-carrier">{{'upload_history.missing_carrier_name_txt' | translate}}: {{ count }} {{'common.shipments_txt' | translate}}</div>
  <div>{{'shipments.ocean_shipments.add_carrier_name_placeholder_txt' | translate}}</div>
</div>

<div class="mt-40" fxLayout fxLayoutAlign="space-between center">
  <button mat-flat-button class="tertiary easy-button mr-20" (click)="proceed()">{{'actions.proceed_anyway_txt' | translate}}</button>
  <button mat-flat-button class="easy-button" [mat-dialog-close]="false">{{'upload_history.add_carrier_name_txt' | translate}}</button>
</div>
